import { GuerillaView } from './GuerillaView';

export const hr = {
  GuerillaView
};
